import React, { useContext, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography, Grid } from '@mui/material';
import PetCard from './PetCard';
import { layoutButtonPillRadius } from '../theme/colors';
import { PetsContext } from '../contexts/PetsContext';
import NewPetDialog from './NewPetDialog';
const MyPets = () => {
  const [showNewPetDialog, toggleShowNewPetDialog] = React.useState(false);
  const { petsList } = useContext(PetsContext);
  // const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Meus Pets - TudoPets.app';
  }, []);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
      <Typography variant="pageTitle">
        Meus Pets
      </Typography>

      <Grid container spacing={2}>
        {petsList.sort((a, b) => a.id - b.id).map((pet) => (
          <Grid item xs={6} sm={4} md={3} sx={{ display: 'flex' }} key={pet.id}>
            <PetCard pet={pet} />
          </Grid>
        ))}
      </Grid>

      <Box sx={{ width: '361px', height: '53px' }}>
        <Button
          onClick={() => toggleShowNewPetDialog(true)}
          sx={{ width: '100%', borderRadius: layoutButtonPillRadius, fontFamily: 'Nunito', fontSize: '16px', fontWeight: 400, lineHeight: '24px' }} variant="contained">
          Adicionar Pet
        </Button>
      </Box>

      {showNewPetDialog && <NewPetDialog open={showNewPetDialog} handleClose={() => toggleShowNewPetDialog(false)} />}
    </Box>
  );
};

export default MyPets;
